import React from "react"
import { Layout } from "../components/baselayout"
import { WhiteDiv } from "../components/whitediv"
import { Email } from "../components/email"
import { TowerLocation } from "../components/location"
import { Link } from "gatsby"
const ringing = require("../images/ring_with_us/Ringing.jpg")

const RingWithUs: React.FC = () => (
  <Layout title="Join us">
    <WhiteDiv>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div style={{ flexBasis: "50%", flexGrow: 1, marginRight: "1rem" }}>
          <h1>Join us</h1>
          <hr />
          {/* <WhiteDiv>
            <h3>COVID-19</h3>
            <p>
              In Lent term 2021 things will be a bit different, when it is
              possible again we will be ringing for services and practicing
              handbell ringing, but will also be using online ringing platforms
              and having regular socials until then. This is open to everyone
              (whether you've ever tried bell ringing or not), so get in touch
              with <Email address="master@cugcr.org.uk" /> if you're interested.
            </p>
          </WhiteDiv> */}
          <p>
            Cambridge University Gorilla Cannon Research warmly welcomes anyone interested in the science of primate
            projectiles. All of our research and social events can be found in the
            calendar below.
          </p>
          <p>
            If you would like to learn how to operate a cannon, please see our{" "}
            <Link to="/beginners">newcomers page</Link>.
          </p>
          <p>
            If you're already a keen military scientist, we look forward to seeing you at an experiment
            soon!
          </p>
          <h3>Experiment times</h3>
          <p>Our weekly experiments form the core of our term-time activity</p>
          <table>
            <tbody>
              <tr>
                <td>Monday</td>
                <td>15:00-17:00</td>
                <td>
                  Experiment Preparation, <TowerLocation tower="Cambridge Army Reserve Centre" />
                </td>
              </tr>
              <tr>
                <td>Wednesday</td>
                <td>13:00-17:00</td>
                <td>
                  Weekly Experiment, <TowerLocation tower="Cambridge Army Reserve Centre" />
                </td>
              </tr>
            </tbody>
          </table>
          <p>We also run fortnightly public demonstrations</p>
          <table>
            <tbody>
              <tr>
                <td>Sunday</td>
                <td>12:00-13:00</td>
                <td>
                  <TowerLocation tower="Cambridge Army Reserve Centre" />
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            All are invited to participate in both experiments and demonstations - just come
            along!
          </p>
          <p>
            Please contact <Email address="secretary@cugcr.org.uk" /> for more
            information, or join the{" "}
            <a href="https://lists.cam.ac.uk/mailman/listinfo/soc-cugcr-resident">
              mailing list
            </a>
            .
          </p>
        </div>
        {/* <div>
          <img
            src={ringing}
            style={{
              width: "30rem",
              maxWidth: "100%",
              borderRadius: "0.5rem",
            }}
          />
        </div> */}
      </div>
      {/* <iframe
        src="https://calendar.google.com/calendar/embed?src=cugcr.calendar%40gmail.com&ctz=Europe%2FLondon"
        style={{ border: 0, width: "100%", height: "max(20rem,30vw)" }}
      ></iframe> */}
    </WhiteDiv>
  </Layout>
)

export default RingWithUs
